import React from 'react';
import { Icon, Dropdown, Button } from 'semantic-ui-react';
import { FormattedMessage, useIntl } from 'react-intl';
import { presentationOptions } from '@/constants/states';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const RequestsTableSettingsMenu = ({ category }) => {
  const intl = useIntl();
  const { singleSorting } = Selectors.useRequestsTableSettingsMenu({ category });
  const toggleSingleSorting = Events.useToggleRequestSingleSorting(category);
  const togglePresentation = Events.useToggleRequestsPresentation(category);

  return (
    <Dropdown
      icon={null}
      pointing="top left"
      trigger={(
        <Button
          basic
          title={intl.formatMessage({ id: 'actions.table.settings.title' })}
          icon="cog"
          className="aridhia-requests-table-settings-menu-button"
          circular
        />
      )}
      className="aridhia-requests-table-settings-menu"
    >
      <Dropdown.Menu>
        <Dropdown.Item
          as="a"
          selected={false}
          onClick={() => toggleSingleSorting()}
        >
          <Icon name="sort alphabet down" />
          <FormattedMessage id={singleSorting ? 'actions.sort.multiple' : 'actions.sort.single'} />
        </Dropdown.Item>
        <Dropdown.Item
          as="a"
          selected={false}
          onClick={() => togglePresentation({ display: presentationOptions.CARDS })}
        >
          <Icon name="grid layout" />
          <FormattedMessage id="actions.display.cards" />
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};
export default RequestsTableSettingsMenu;
